export enum HelpResourcesRoutesEnum {
  ContactUs = 'contact-us',
  Feedback = 'feedback',
  InformationLinks = 'information-links',
}
